import _axios from '@/plugins/axios';
import { PrescriptionError } from '../../../lib/Errors';

export default {
    async getPrescriptionsByPatientId (patientId) {
        const response = await _axios.get(`/patientprescription/${patientId}`);
        if (response.data.resFlag) {
            return response.data;
        }
        throw new PrescriptionError('Error getting prescription info');
    },
    async fdaSearch (body) {
        const response = await _axios.post('/patientprescription/fdasearch', body);
        if (response.data.resFlag) {
            return response.data;
        }
        throw new PrescriptionError('Error getting prescriptions');
    },
    async deletePrescription (prescriptionId) {
        const response = await _axios.delete(`/patientprescription/${prescriptionId}`);
        if (response.data.resFlag) {
            return response.data;
        }
        throw new PrescriptionError('Error deleting prescription');
    },
    async updatePrescription (prescriptionId, body) {
        const response = await _axios.put(`/patientprescription/${prescriptionId}`, body);
        if (response.data.resFlag) {
            return response.data;
        }
        throw new PrescriptionError('Error updating prescription');
    },
    async addPrescription (body) {
        const response = await _axios.post('/patientprescription/', body);
        if (response.data.resFlag) {
            return response.data;
        }
        throw new PrescriptionError('Error adding prescription');
    },
};
